/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * UmbrellaIcon
 */
export default class UmbrellaIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12.255 1v.003h.046c4.99.128 8.565 3.431 10.648 9.68.294.884-.671 1.654-1.467 1.172-1.096-.664-1.94-.98-2.482-.98-.428 0-.812.216-1.205.731a1 1 0 01-1.285.266c-1.195-.672-2.06-.997-2.51-.997-.282 0-.615.16-1 .526V18c0 1.132.287 1.644.74 1.863.22.106.44.137.76.137s.54-.03.76-.137c.453-.219.74-.73.74-1.863a1 1 0 012 0c0 1.865-.688 3.094-1.872 3.665-.558.269-1.03.335-1.628.335-.598 0-1.07-.066-1.628-.335-1.127-.544-1.805-1.685-1.867-3.403L11 18v-6.818c-.279-.212-.527-.307-.745-.307-.45 0-1.315.325-2.51.997a1 1 0 01-1.285-.266c-.393-.515-.776-.731-1.205-.731-.542 0-1.385.316-2.482.98-.795.482-1.76-.288-1.466-1.171C3.397 4.415 6.987 1.11 12 1.003V1h.255zm-.127 2.001L12.255 3C8.676 3 5.972 4.966 4.091 9.052c.414-.118.801-.177 1.164-.177.827 0 1.571.305 2.21.878 1.138-.581 2.052-.878 2.79-.878.658 0 1.282.227 1.873.655.591-.428 1.215-.655 1.872-.655.738 0 1.652.297 2.791.878.638-.573 1.382-.878 2.209-.878.363 0 .75.06 1.164.177-1.829-3.972-4.435-5.941-7.868-6.047L12.128 3z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

